import React, { useState } from 'react';
import {
  Button,
  FormSelect,
  FormInput,
  InlineEditColumnProps,
  InlineEditTable,
  Widget,
  FormSubmitButton,
  FormatText,
  MasterDetailForm,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { SelectValue } from 'antd/lib/select';
import { hasPermission } from '@app/helpers/permissions';

import { CrfAcronimoAgrupador } from '@app/api/crf/acronimo/agrupador/acronimosAgrupador';

interface TipoAgrupadorProps {
  titulo: string;
  data: CrfAcronimoAgrupador[];
  disciplinas: { text: string; value: string }[] | undefined;
  tipos: { text: string; value: string }[] | undefined;
  handleDelete(id: string): Promise<unknown>;
  handleCreate: (record: CrfAcronimoAgrupador) => Promise<CrfAcronimoAgrupador | undefined>;
  handleUpdate: (record: CrfAcronimoAgrupador) => Promise<boolean>;
  shouldUpdate: (needed: boolean) => void;
  isUpdate: boolean;
}

export const initialState: CrfAcronimoAgrupador = {
  id: '',
  sigla: '',
  disciplinaId: '',
  tipoId: '',
  acronimoId: ''
};

const CRFAcronimoAgrupadorTable = (props: TipoAgrupadorProps) => {
  const { titulo, data, disciplinas, tipos, isUpdate, handleCreate, handleUpdate, handleDelete, shouldUpdate } = props;
  const [acronimoAgrupador, setAcronimoAgrupador] = useState<CrfAcronimoAgrupador>(initialState);

  const customColumns = () => {
    return [
      {
        title: 'Sigla',
        dataIndex: 'sigla',
        width: '10%',
        renderEdit: () => <FormInput name="sigla" disabled={false} required />,
      },
      {
        title: 'Disciplina',
        dataIndex: 'disciplinaId',
        key: 'disciplinaId',
        options: disciplinas,
        width: '40%',
        render: (_: string, record: CrfAcronimoAgrupador) => {
          const option = disciplinas && disciplinas.find(f => f.value === record.disciplinaId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="disciplinaId" options={disciplinas} required disabled={false} />,
      },
      {
        title: 'Tipo',
        dataIndex: 'tipoId',
        key: 'tipoId',
        options: tipos,
        width: '40%',
        render: (_: string, record: CrfAcronimoAgrupador) => {
          const option = tipos && tipos.find(f => f.value === record.tipoId);
          return option ? option.text : '';
        },
        renderEdit: () => <FormSelect name="tipoId" options={tipos} required disabled={false} />,
      },
      {
        render: (item: CrfAcronimoAgrupador) =>
          hasPermission(['ACRONIMOS_CADASTRAR']) ? (
            <>
              <Button
                confirm="Deseja realmente excluir este registro?"
                okText="Confirmar"
                onClick={() =>
                  handleDelete(item.id)
                    .then(() => {
                      !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
                    })
                }
                icon="science-minus"
              />
            </>
          ) : (
            <></>
          ),
      },
    ] as InlineEditColumnProps<CrfAcronimoAgrupador>[];
  };

  const handleChangeSigla = (sigla: string) => {
    if (sigla.length > 0 && acronimoAgrupador) {
      setAcronimoAgrupador({ ...acronimoAgrupador, sigla });
    }
  };

  const handleChangeDisciplina = (disciplina: SelectValue) => {
    if (disciplina.valueOf && acronimoAgrupador) {
      setAcronimoAgrupador({ ...acronimoAgrupador, disciplinaId: disciplina.toString() });
    }
  };

  const handleChangeTipo = (grupo: SelectValue) => {
    if (grupo.valueOf && acronimoAgrupador) {
      setAcronimoAgrupador({ ...acronimoAgrupador, tipoId: grupo.toString() });
    }
  };

  const handleClick = async () => {
    if (acronimoAgrupador) {
      const result = await handleCreate(acronimoAgrupador);
      if (result) {
        !isUpdate ? shouldUpdate(true) : shouldUpdate(false);
      }
    }
  };

  const { Panel } = Collapse;

  return (
    <>
      <Collapse bordered={false} defaultActiveKey={['2']} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="2" header="Acrônimos Agrupador" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                hasPermission(['ACRONIMOS_CADASTRAR', 'ACRONIMOS_EDITAR']) && (
                  <FormSubmitButton type="primary" onClick={handleClick}>
                    <FormatText id="ui.commons.save" uppercase />
                  </FormSubmitButton>
                ),
              ]}>
              <InlineEditTable
                className="removeScrollbar"
                rowKey="id"
                columns={customColumns()}
                updateItem={handleUpdate}
                dataSource={data}
                pagination={false}
                disablenotification={false}
              />
              <fieldset>
                <legend>Inserir Nova Linha</legend>
                <FormInput span={3} label="Sigla" name="sigla" onChange={e => handleChangeSigla(e.target.value)} />
                <FormSelect
                  showSearch
                  label="Disciplina"
                  name="disciplinaId"
                  options={disciplinas}
                  span={4}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  onSelect={e => handleChangeDisciplina(e)}
                />
                <FormSelect
                  showSearch
                  label="Tipo"
                  name="tipoId"
                  options={tipos}
                  span={4}
                  optionFilterProp="children"
                  filterOption={(input, item) => {
                    return item.props.children.props.id
                      .toString()
                      .toLowerCase()
                      .includes(input.toLowerCase());
                  }}
                  onSelect={e => handleChangeTipo(e)}
                />
              </fieldset>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default CRFAcronimoAgrupadorTable;
